// extracted by mini-css-extract-plugin
module.exports = {"container":"learningSimilarCourses_container__UKQ_6","title":"learningSimilarCourses_title__i3QCr"};